import { useQueryClient } from 'react-query';
import { useCallback } from 'react';
import { CacheKeys } from '../constants';
export const useLocalMatchDeletion = () => {
    const queryClient = useQueryClient();
    const mutate = useCallback((data) => {
        queryClient.setQueryData([CacheKeys.PENDING_MATCHES], (prev) => {
            if (!prev)
                return [];
            return prev.filter((m) => m.id !== data.id);
        });
        queryClient.setQueryData([CacheKeys.MATCHES], (prev) => {
            if (!prev)
                return undefined;
            return Object.assign(Object.assign({}, prev), { pages: prev.pages.map((page) => {
                    return Object.assign(Object.assign({}, page), { records: page.records.filter((match) => match.id !== data.id) });
                }) });
        });
        queryClient.setQueryData([CacheKeys.MATCH, data.id], () => undefined);
    }, []);
    return { mutate };
};
//# sourceMappingURL=useLocalMatchDeletion.js.map